import React, { useEffect, useState, useRef } from 'react'
import ProfileNavbar from '../../../../components/Profile-navbar/profile-navbar'
import './assess.css'
import { tests } from '../../../../data'
import Categories from './categories'
import Menu from './menu'
import { Container, Form,Card, Row, Col, Button } from 'react-bootstrap'

const allCategories = ['All', ...new Set(tests.map((test) => test.category))]

const Assess = () => {
  const [testItems, setTestItems] = useState(tests);
  const [categories,setCategories] = useState(allCategories);
  const [searchText,setsearchText] = useState('');
  const handleSearch= (e) => {
    e.preventDefault();
    const gotText = searchText.toLowerCase();
   
    setTestItems(
      testItems.filter((testItem) => {
        
       const newItems = testItem.field.toLowerCase().includes(gotText)

       const topics = testItem.topics
       const filteredTopics = topics.toString().toLowerCase().includes(gotText)  
       console.log(filteredTopics)     
        return newItems || filteredTopics
        // ||
        // testItem.topics.toLowerCase().includes(gotText)

      })
    )
  
  }

  

  const filterTests = (category) => {
    if (category === 'All'){
      setTestItems(tests);
      return;
    }
    const newTests = tests.filter((test) => test.category === category);
    setTestItems(newTests);

   
  };
  
 

  return (
    <div>
       <ProfileNavbar/>
       <Container fluid className='py-5 px-1 px-md-5 px-sm-2'>
          <div className='align-items-center text-center mt-5'>
          <p className='test-head'>IQ TESTS</p>
          <Form className='px-md-5 mx-md-5 my-5'>
            <Form.Group>
              <div className='d-flex'>
            <Form.Control type='text' value={searchText} style={{borderRadius:'0'}}placeholder='Type to search for a specific test' onChange={(e) => {setsearchText(e.target.value)
              if(e.target.value === ''){
                setTestItems(tests)
              }
            }
            } />
           
                <button className='search-btn' onClick={handleSearch}>Search</button>
                </div>
            
            </Form.Group>
          </Form>
          </div>
          <Categories categories={categories} filterTests={filterTests} />
          <Menu tests={testItems}/>
          
       </Container>
        
    </div>
  )
}

export default Assess
